/* @flow */

import React from 'react';
import { injectIntl } from 'react-intl';
import formStyles from '../styles/FormGeneral.scss';

type ComponentProps = {|
    intl: intlShape,
    errors?: string,
|};

export const ErrorMessageComponent = ({ errors }: ComponentProps) => {
    return errors ? <div className={formStyles.error}>{errors}</div> : null;
};

export const ErrorMessage = injectIntl(ErrorMessageComponent);
